module.exports = __webpack_public_path__ + "img/Frame338.5537b948.png";